export const Constant = {
    HEADING: "Service Distribution",
    HEADINGTEXT: "Download the country data, then upload the corrected version, ensuring no deletions or edits to countries, products, or variations.",
    UPLOAD: "Upload Data",
    DOWNLOAD: "Download Data",
    VALIDATIONTITLE:"Validation Error :",
    VALIDATIONSUBTITLE:"Please Correct Errors and Reupload a file",
    CONTENTHEADING:"Instruction for Service Distribution:",
    INS1:"Utilization % for a component cannot be a negative number.",
    INS2:"The total of all the components utilization % cannot be more than 100% for a specific country.",
    CONFIRM:"Confirm",
    OK:"OK",
    CONFIRMBOXTEXT:"The data is fine and ready to calculate.",
    INPUTERROR1:"Invalid data input : Please check input values!",
    INPUTERROR2:"Overall Utilization % should be equal to 100! Please check the input values.",
    WRONGFILETYPE:"Please upload correct file. Use excel template for reference.",
    EMPTYFILEERROR:"No data found!. Please check the uploaded file.",
    INVALIDHEADERERROR:"Columns are missing! Please check the uploaded file.",
    FAILEDERROR:"File upload Failed. Please check the uploaded file.",
    
}

